export default __webpack_public_path__ + "static/media/380.903829e8.png";